import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSellerAuth } from "../../context/SellerAuthContext";
import { auth } from "../../services/firebase";

const SellerDetailsStep = () => {
  const { registrationData, setRegistrationData, saveSellerDetails } =
    useSellerAuth();
  const [mobileMoneyNumber, setMobileMoneyNumber] = useState("");
  const [ghanaCardId, setGhanaCardId] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setRegistrationData({
      ...registrationData,
      mobileMoneyNumber,
      ghanaCardId,
    });
    await saveSellerDetails(
      auth.currentUser.uid,
      mobileMoneyNumber,
      ghanaCardId
    );
    navigate("/dashboard");
  };

  return (
    <div className="p-4">
      <h1 className="text-xl">
        Enter your Mobile Money and Ghana Card details
      </h1>
      <input
        type="text"
        value={mobileMoneyNumber}
        onChange={(e) => setMobileMoneyNumber(e.target.value)}
        placeholder="Mobile Money Number"
        className="w-full p-2 mt-2 border rounded"
      />
      <input
        type="text"
        value={ghanaCardId}
        onChange={(e) => setGhanaCardId(e.target.value)}
        placeholder="Ghana Card ID"
        className="w-full p-2 mt-2 border rounded"
      />
      <button
        onClick={handleSubmit}
        className="mt-4 p-2 bg-blue-500 text-white rounded"
      >
        Complete Registration
      </button>
    </div>
  );
};

export default SellerDetailsStep;
